import { useMutation } from '@tanstack/react-query';
import { downloadBlob } from '@noor/lib';
import { vendorBroadcastApi } from '@/entities/vendor-broadcast';

/**
 * Download a broadcast attachment. Silent on success (the browser takes over);
 * failures surface through the global MutationCache toast.
 */
export function useDownloadBroadcastFile() {
  return useMutation({
    mutationFn: async ({ path, filename }: { path: string; filename: string }) => {
      const blob = await vendorBroadcastApi.downloadFile(path);
      return { blob, filename };
    },
    onSuccess: ({ blob, filename }) => {
      downloadBlob(blob, filename);
    },
  });
}
